import { createUseStyles } from '../../theme/theming';

const useWebinarPromotionPage = createUseStyles((theme) => {
  return {
    webinarSuperContainer: {
      display: 'flex',
      justifyContent: 'center',
      background: theme.colors.background1,
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `${theme.spacing.padding.medium}px ${theme.spacing.padding.regular}px`
          : `${theme.spacing.padding.regular}px ${theme.spacing.padding.medium}px`,
      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      },
      '& h2,& h3,& p': {
        margin: '0'
      }
    },
    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },

    videoTestimonialContainer: {
      width: '100%',
      maxWidth: '1440px',
      fontFamily: theme?.typography?.fontFamily
    },

    webinarCarousel: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: '32px'
    },

    '@media screen and (max-width: 767px)': {
      webinarCarousel: {
        display: 'flex',
        flexDirection: 'column-reverse'
      }
    },

    iframeSuperContainer: {
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },

    iframeContainer: {
      width: '100%',
      position: 'relative',
      aspectRatio: '4/3',
      // top: "6%",
      // left: '5%'
      borderRadius: '8px',
      overflow: 'hidden'
    },

    offerText: {
      textAlign: 'center',
      color: theme?.colors?.lightblack,
      marginBottom: '5% !important',
      fontWeight: '700'
    },
    offerPrice: {
      fontSize: theme.typography.fontSize.h5,
      fontWeight: '600'
    },
    priceContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: 'fit-content'
    },
    originalPrice: {
      textDecoration: 'line-through',
      color: 'rgba(51, 51, 51, 0.6)'
    },
    offerDiscount: {
      color: '#08BD80',
      fontWeight: '600'
    },
    bottomContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '5%'
      // padding: '0px 5% 0px 5%'
    },
    iframe: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius.small
    },

    videoDetails: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '20px'
    },

    videoDetailsHeading: {
      fontSize: theme.typography.fontSize.h3,
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '48px',
      margin: '0',
      letterSpacing: '-1px',
      wordBreak: (wordBreakValue) => wordBreakValue || 'break-word',
      color: theme?.colors?.font1
    },
    courseViewContainer: {
      width: '645px',
      height: 'fit-content',
      backgroundColor: '#f4f9ff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      padding: '24px',
      borderRadius: '10px'
    },
    bannerContainer: {
      width: '100%',
      background: theme?.colors?.bannerColor,
      color: theme?.colors?.bannerCtaColor,
      fontWeight: '600',
      textAlign: 'center',
      padding: '10px 10px 23px 40px',
      wordWrap: 'break-word',
      position: 'relative',
      fontSize: '18px',
      transform: 'rotate(180deg)',
      clipPath:
        'polygon(0 0, 100% 0, 100% calc(100% - 10px), 0 calc(100% - 10px), 15px calc(50% - 10px/2))'
    },

    bannerContainerText: {
      transform: 'rotate(180deg)'
    },
    courseDetailsTags: {
      display: 'flex'
    },
    courseDetailTag: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '20px',
      color: theme?.colors?.font1,
      '& div': {
        fontSize: theme.typography.fontSize.body,
        marginLeft: '10px'
      }
    },
    courseDetailContent: {
      fontSize: theme.typography.fontSize.body,
      lineHeight: '21px',
      wordBreak: 'break-word',
      color: theme?.colors?.font1,
      whiteSpace: 'pre-wrap',
      width: '80%'
    },

    courseDetailViewFullDetails: {
      cursor: 'pointer',
      fontSize: theme.typography.fontSize.body,
      lineHeight: '24px',
      color: theme?.colors?.font1,
      marginTop: '-20px',
      wordBreak: 'break-word'
    },

    courseDetailTime: {
      color: '#EB5757',
      fontWeight: '600'
    },

    // webinarButtonContainer: {
    //   marginBottom: '20px'
    // },

    iconBackground: {
      display: 'flex',
      width: '36px',
      height: '36px',
      backgroundColor: theme?.colors?.icon,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '6px'
    },
    '@media (max-width: 767px)': {
      bannerContainerText: {
        fontSize: '16px'
      },
      courseViewContainer: {
        width: '100%'
      },
      webinarSuperContainer: {
        padding: '20px 10px 60px 20px'
      },
      videoCarousel: {
        flexDirection: 'column-reverse',
        gap: '20px'
      },

      videoCarouselContainer: {
        height: 'max-content',
        paddingRight: '10px'
      },

      videoDetails: {
        width: '100%'
      },

      videoDetailsHeading: {
        lineHeight: 'normal'
      },
      videoTestimonialTitle: {
        // fontSize: '24px',
        lineHeight: '36px',
        letterSpacing: '-1px'
      },

      videoDetailsContent: {
        marginTop: '4px'
      }
    },
    '@media (max-width: 420px)': {
      bannerContainerText: {
        fontSize: '14px'
      }
    }
  };
});

export default useWebinarPromotionPage;
